import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../AxiosBaseApi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SliderComponent from "./SliderComponent";

const useStyles = makeStyles({
  formContainer: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  phoneInputContainer: {
    display: "flex",
    flexDirection: "column",
  },
  inputField: {
    marginBottom: "20px",
  },
  icon: {
    marginRight: "8px",
  },
  actionButtons: {
    display: "flex",
    gap: "10px",
  },
  footer: {
    marginTop: "20px",
    textAlign: "center",
  },
});

export const generateCaptcha = () => {
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let captcha = "";
  for (let i = 0; i < 4; i++) {
    captcha += chars[Math.floor(Math.random() * chars.length)];
  }
  return captcha;
};

const Register = () => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const [countryCode, setCountryCode] = useState("+91"); // Default country code
  const [referralCode, setReferralCode] = useState(undefined);
  const history = useNavigate();
  const [data, setData] = useState({
    verification: null,
    username: null,
    password: null,
  });
  const location = useLocation();
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [inputValue, setInputValue] = useState("");
  const [message, setMessage] = useState("");
  const [usernameError, setUsernameError] = useState("");

  useEffect(() => {
    // URL se query parameters nikalne ke liye
    const queryParams = new URLSearchParams(location.search);
    const rCode = queryParams.get("code");

    // Referral code ko state me set kar rahe hain
    if (rCode) {
      setReferralCode(rCode);
    }
  }, [location.search]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
    if (name === "username") {
      if (value.length < 10) {
        setUsernameError("Username must be at least 10 characters");
      } else {
        setUsernameError("");
      }
    }
  };




  
  const handleChangeCode = (e) => {
    setReferralCode(e.target.value);
  };
  useEffect(() => {
    const mamberID = localStorage.getItem("mamberId");
    if (mamberID) {
      history("/");
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (inputValue === captcha) {
      setMessage("CAPTCHA Verified ✅");

      const datas = new FormData();
      datas.append("username", data.username);
      datas.append("password", data.password);
      datas.append("code", data.verification);
      datas.append("refcode", referralCode || undefined);

      try {
        const response = await axiosInstance
          .post("/bet.php?action=register", datas)
          .then((res) => {
            if (res.status === 200) {
              if(res.data[0].status === "success"){

                setTimeout(() => {
                  history("/login");
                }, 500);
              }else{
                toast.error(res.data[0].status);
              }

            } else {
               toast.error(res.data[0].status);
            }
          });
      } catch (error) {
        console.log("Error", error);
      }
    } else {
      setMessage("CAPTCHA Incorrect ❌");
      setCaptcha(generateCaptcha()); // Refresh CAPTCHA
    }
  };

  const handleNavigation = (path) => {
    history(path);
  };
  const handleCountryCodeChange = (event) => {
    setCountryCode(event.target.value);
  };
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div style={{ width: "100%", backgroundColor:"#3d3b6f" }}>
        <Box
          style={{
            height: "8vh",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 14px",
          }}
        >
          <ChevronLeftIcon
            fontSize="medium"
            style={{
              color: "#fff",
            }}
          />
          <Typography variant="body2" style={{ color: "#fff" }}>
            Register
          </Typography>
          <Typography
            variant="subtitle2"
            style={{ color: "#fff" }}
          ></Typography>
        </Box>

        {/* <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        > */}
         <SliderComponent />
        {/* </Box> */}
        <Box component="form" onSubmit={handleSubmit}>
          <div className={classes.formContainer}>
            {/* Phone Input */}

            <div className={classes.phoneInputContainer}>
              <div className={classes.inputField}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1" style={{ color: "#fff" }}>
                    Phone number
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                  }}
                >
                  <FormControl
                    variant="outlined"
                    size="small"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // Removes the border
                        },
                      },
                    }}
                  >
                    <Select
                      value={countryCode}
                      onChange={handleCountryCodeChange}
                    >
                      <MenuItem value="+91">+91</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    sx={{
                      width: "280px",
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // Removes the border
                        },
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px #fff inset", // Forces white background on autofill
                        WebkitTextFillColor: "#000", // Sets text color to black
                      },
                    }}
                    name="username"
                    id="username"
                    onChange={handleChange}
                    size="small"
                    placeholder="Please enter the phone number"
                    // error={!!usernameError}
                    // helperText={usernameError ? usernameError : ""} 
                  />
                </Box>
                <Typography color="#fff">{usernameError ? usernameError : ""} </Typography>
              </div>
            </div>

            <div className={classes.phoneInputContainer}>
              <div className={classes.inputField}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1" style={{ color: "#fff" }}>
                    Verification Code
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                  }}
                >
                  <TextField
                    fullWidth
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    required
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // Removes the border
                        },
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px #fff inset", // Forces white background on autofill
                        WebkitTextFillColor: "#000", // Sets text color to black
                      },
                    }}
                    size="small"
                    placeholder="Please enter the verification code"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            style={{
                              color: "#000",
                              backgroundImage: `url('/images/captcha1.jpg')`,
                              borderRadius: "0%",
                              fontWeight: "700",
                              fontSize: "17px",
                            }}
                            onClick={() => setCaptcha(generateCaptcha())}
                          >
                            {captcha} 🔄
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
                {message}
              </div>
            </div>

            <div className={classes.phoneInputContainer}>
              <div className={classes.inputField}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1" style={{ color: "#fff" }}>
                    Set Password
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                  }}
                >
                  <TextField
                    fullWidth
                    onChange={handleChange}
                    name="password"
                    type={showPassword ? "text" : "password"} // Toggle password visibility
                    id="password"
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // Removes the border
                        },
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px #fff inset", // Forces white background on autofill
                        WebkitTextFillColor: "#000", // Sets text color to black
                      },
                    }}
                    size="small"
                    placeholder="Set Password"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClickShowPassword}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                </Box>
              </div>
            </div>

            <div className={classes.phoneInputContainer}>
              <div className={classes.inputField}>
                <Box style={{ display: "flex", alignItems: "center" }}>
                  <Typography variant="body1" style={{ color: "#fff" }}>
                    Invite Code
                  </Typography>
                </Box>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                  }}
                >
                  <TextField
                    fullWidth
                    value={referralCode}
                    onChange={handleChangeCode}
                    name="referralCode"
                    type="text"
                    id="referralCode"
                    required
                    sx={{
                      backgroundColor: "#fff",
                      borderRadius: "10px",
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none", // Removes the border
                        },
                      },
                      "& input:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 1000px #fff inset", // Forces white background on autofill
                        WebkitTextFillColor: "#000", // Sets text color to black
                      },
                    }}
                    size="small"
                    placeholder="Please enter the invitation Code"
                  />
                </Box>
              </div>
            </div>
            <FormControlLabel
              control={
                <Checkbox
                  defaultChecked
                  sx={{
                    "& .MuiSvgIcon-root": {
                      color: "white", // Set the checkbox icon color to white
                    },
                  }}
                />
              }
              label="I have read and agree"
            />
            <Box
              style={{
                display: "flex",
                justifyContent: "center",

                alignItems: "center",
                flexDirection: "column",
                gap: 10,
              }}
            >
              <Box style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  variant="outlined"
                  type="submit"
                  style={{
                    background: "#f83600",
                    border: 0,
                    borderRadius: "100px",
                    color: "#FFFFFF",
                    cursor: "pointer",
                    display: "inline-block",
                    fontFamily:
                      '-apple-system, system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                    fontSize: "16px",
                    fontWeight: 500,
                    lineHeight: 2.5,

                    minWidth: "294%",
                    padding: "0 1rem",
                  }}
                >
                  Register
                </Button>
              </Box>
              <ToastContainer />
              <Box style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  type="button"
                  onClick={() => handleNavigation("/login")}
                  variant="outlined"
                  style={{
                    border: "1px solid #f83600",
                    borderRadius: "100px",
                    color: "#f83600",
                    cursor: "pointer",
                    display: "inline-block",
                    fontFamily:
                      '-apple-system, system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
                    fontSize: "16px",
                    fontWeight: 500,
                    lineHeight: 2.2,

                    minWidth: "125%",
                    padding: "0 1rem",
                  }}
                >
                  <span
                    style={{
                      textTransform: "capitalize",
                      color: "#fff",
                    }}
                  >
                    I have an account{" "}
                  </span>
                  Log in
                </Button>
              </Box>
            </Box>

          </div>
        </Box>
      </div>
    </>
  );
};

export default Register;
